module.exports = __webpack_public_path__ + "static/img/demand01.4b6434ee.png";